define(["jquery", "wcs.context"], function($, ctx) {
	// define LANG_MSG only if it doesn't exist
	window.LANG_MSG = window.LANG_MSG || {};

	var $deferred = new $.Deferred(),
		url = WCS_CONFIG.get("global::storeMessagesURL") || $('link[rel="vf-store-messages"]').attr('data-href'); // Retrieve the URL with fallback for the obsolete malformed link tag
	// TODO: VFDP-2872 the fallback above is safe to remove after ECOM changes are deployed

	// Provide a fake success in CMS authoring to prevent 404s and improve
	// authoring performance. Store Messages URL is not avilable there
	// because it's a dedicatd single domain for all brands so the relative
	// paths don't exist.
	if(window.isEditMode || window.location.hostname === 'localhost') {
		console.debug('CMS authoring mode detected. Skipping load of Store Messages.');
		$deferred.resolve();
		return $deferred.promise();
	}

	// Quick fail when the URL doesn't exist. This avoids having to wait
	// for the long require() loading timeout which takes 10-30s.
	if(typeof(url) === 'undefined') {
		console.error('No store message translations found.');
		$deferred.reject();
		return $deferred.promise();
	}

	// Display an error message to visitors if the language request fails
	$deferred.fail(function() {
		// sets the scroll to the top when the ajax call finishes
		$(window).scrollTop(0);

		// handle error messages
		var $pageContents = $('.page-contents');
		if($pageContents.children('.page-messaging-js').length === 0) {
			var renderMsgContainer = '<section class="page-messaging page-messaging-js">'+
					'<div></div>'+
					'</section>';
			$pageContents.prepend(renderMsgContainer);
		}
		var errorMsg = '<p class="message error">ERROR LOADING CONTENTS, PLEASE REFRESH THE PAGE.</p>';
		$pageContents.find('.page-messaging-js div').html(errorMsg);
	});

	// Setup AJAX request
	var isJSONPEnabled = url.search("isJSONPEnabled"), // Detect if we're using JSONP
		ajaxOptions = {
			url: ctx.getURLWithContextRoot(url), // Append the Commerce relative path
			type: "GET",
			timeout: 15000,
			dataType: (isJSONPEnabled) ? 'jsonp' : null,
			cache: true,
			crossDomain: (isJSONPEnabled),
			jsonpCallback: (isJSONPEnabled) ? 'jsonpCallback' : null,
			error: function(jqXHR, textStatus) {
				console.error("Error loading store message translations: " + textStatus);
				$deferred.reject();
			},
			success: function(data) {
				window.LANG_MSG = data;
				$deferred.resolve();
			}
		};

	// Make the AJAX request
	$.ajax(ajaxOptions);

	// Provide a promise for various scripts dependencies
	return $deferred.promise();
});